// http://www.primaryobjects.com/2012/11/19/parsing-hostname-and-domain-from-a-url-with-javascript/
const getHostNameFromUrl = (url: string) => {
  const match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
  if (
    match !== null &&
    match.length > 2 &&
    typeof match[2] === 'string' &&
    match[2].length > 0
  ) {
    const hostname = match[2].split('.');
    return hostname[0];
  } else {
    return null;
  }
};

const searchEngines = [
  'google',
  'bing',
  'yahoo',
  'ecosia',
  'naver',
  'duckduckgo',
  'yandex',
  'baidu',
  'daum',
  'qwant',
];

export const inferSourceFromReferrer = (referrer: string) => {
  let utm_source = 'direct';
  let utm_medium;
  if (referrer) {
    // Check if referrer is an internal domain
    const fullUrl = new URL(referrer);
    const referrerHostname = fullUrl.hostname.replace('www.', '');

    // Get current origin hostname from env
    const currentOrigin = process.env.NEXT_PUBLIC_ORIGIN;
    const currentHostname = currentOrigin
      ? new URL(currentOrigin).hostname.replace('www.', '')
      : '';

    // Check if referrer matches current hostname
    const isInternal =
      currentHostname &&
      (referrerHostname === currentHostname ||
        referrerHostname.endsWith(`.${currentHostname}`));

    // If internal referrer, treat as direct
    if (isInternal) {
      return {
        utm_source: 'direct',
        utm_medium: undefined,
      };
    }

    // Process external referrers
    const hostname = getHostNameFromUrl(referrer);
    const searchEngine = searchEngines.find((engine) => engine === hostname);
    if (searchEngine) {
      utm_source = searchEngine;
      utm_medium = 'organic';
    } else {
      utm_source = referrerHostname;
      utm_medium = 'referral';
    }
  }
  return {
    utm_source,
    utm_medium,
  };
};
